import { render, staticRenderFns } from "./deathcertificate.vue?vue&type=template&id=d9bce426&"
import script from "./deathcertificate.vue?vue&type=script&lang=js&"
export * from "./deathcertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports